import { render, staticRenderFns } from "./ReturnOrderList.vue?vue&type=template&id=6cde5609&scoped=true"
import script from "./ReturnOrderList.vue?vue&type=script&lang=js"
export * from "./ReturnOrderList.vue?vue&type=script&lang=js"
import style0 from "./ReturnOrderList.vue?vue&type=style&index=0&id=6cde5609&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cde5609",
  null
  
)

export default component.exports